<div class="barcode-div" [ngClass]="isCorporate ? 'bg-corporate-primary' : 'bg-primary'">
  <fgb-mobile-page-header
    [isHomePage]="isHomePage"
    [showBalance]="showBalance"
    [showQr]="showQr"
    [pageTitle]="pageTitle"
    [backButtonLink]="backButtonLink"
  ></fgb-mobile-page-header>
  <ng-container *ngIf="isWalletPage">
    <div class="container pb-3">
      <div class="w-100 qr-div bg-glass mb-3">
        <div class="qr bg-white d-flex justify-content-center mx-auto" *ngIf="barcode$ | async as barcode">
          <qrcode [qrdata]="barcode.Barcode" [width]="120" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
        </div>
        <div class="font-size-12 text-center text-white">
          {{ 'wallet.page.scan.qr' | translate }}
        </div>
      </div>

      <!-- points -->
      <div *ngIf="!isJuniorBlueBirds" class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex points-item w-100 justify-content-between bg-glass">
          <label class="mb-0 font-size-12 fw-normal">{{ 'member.card.points.balance' | translate }}</label>
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-3">loyalty</span>
            <div class="font-size-18 font-heading">
              {{ pointsBalance$ | async | number: '1.0-0' : 'en-US' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
